import Script from 'next/script'
import { useTranslation } from 'next-i18next'
import { FC, useEffect, useState } from 'react'
import { createGlobalStyle } from 'styled-components'

import sessionStore from '@/stores/sessionStore'

import * as S from './CookieControl.styles'
import CookieControlConfig from './CookieControlConfig'

// Styled components should be created outside components to prevent recreation on each render
const CookieControlGlobalStyle = createGlobalStyle`${S.CookieControl}`

const CookieControl: FC = () => {
	const user = sessionStore((state) => state.session?.user)
	const loadingSession = sessionStore((state) => state.loadingSession)
	const [scriptLoaded, setScriptLoaded] = useState(false)
	const [initialised, setInitialised] = useState(false)
	const { t } = useTranslation(['cookiecontrol'])

	useEffect(() => {
		if (window.CookieControl && !loadingSession && !initialised) {
			const config = CookieControlConfig(t, user)

			window.CookieControl.geoTest(config.product, config.apiKey, (response) =>
				geoTestCallback(config, response)
			)

			setInitialised(true)
		}
	}, [scriptLoaded, initialised, loadingSession, t, user])

	function geoTestCallback(config, response): void {
		if (
			response.country === 'US' ||
			response.country === 'GB' ||
			response.withinEU
		) {
			window.CookieControl.load(config)

			// Added a custom event handler to track accept clicks in CCPA mode, since the onAccept hook only fires on load
			if (response.country === 'US') {
				setTimeout(() => {
					if (document.getElementById('ccc-notify-accept')) {
						document
							.getElementById('ccc-notify-accept')
							.addEventListener('click', () => {
								window.dataLayer.push({
									event: 'genericevent',
									category: 'Analytics Cookies',
									action: 'Clicked',
									label: 'Accept',
								})

								window.amplitude
									.getInstance()
									.logEvent('Accept Analytics Cookies Clicked', {
										CookieControlMode: window.CookieControl.config().mode,
										CurrentPath: window.location.pathname,
									})

								window.dataLayer.push({
									event: 'genericevent',
									category: 'Marketing Cookies',
									action: 'Clicked',
									label: 'Accept',
								})

								window.amplitude
									.getInstance()
									.logEvent('Accept Marketing Cookies Clicked', {
										CookieControlMode: window.CookieControl.config().mode,
										CurrentPath: window.location.pathname,
									})
							})
					}
				}, 1000)
			}
		} else {
			window.gtag('consent', 'update', {
				analytics_storage: 'granted',
				ad_storage: 'granted',
				ad_personalization: 'granted',
				ad_user_data: 'granted',
				wait_for_update: 500,
			})
			window.amplitude.getInstance().enableTracking()
		}
	}

	return (
		<>
			<CookieControlGlobalStyle />
			<Script
				strategy="lazyOnload"
				src="https://cc.cdn.civiccomputing.com/9/cookieControl-9.x.min.js"
				onLoad={() => {
					setScriptLoaded(true)
				}}
			></Script>
		</>
	)
}

export default CookieControl
